export default __webpack_public_path__ + "static/image4-3c203210f830c37a84286427781199e5.jpeg";